// console.warn([
//   `[WARNING]: The root "langchain/agents/openai/output_parser" entrypoint is deprecated.`,
//   `Please use either "langchain/agents/openai/output_parser" specific entrypoint instead.`
// ].join("\n"));
export * from "../openai_functions/output_parser.js";
export * from "../openai_tools/output_parser.js";
